import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader = () => {
  return (
    <div className='loader'>
        {/* sx={{ display: 'flex' }} */}
     <Box >
      <CircularProgress size={"10rem"} sx={{color:"white"}} />
    </Box>
    </div>
  )
}

export default Loader
